export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      gallery: "Gallery",
      contact: "Contact",
      bookAppointment: "Book Appointment",
      backToHome: "Back to Home"
    },
    navigation: {
      backToHome: "Back to Home"
    },
    hero: {
      name: "Pritish Nanda Pradhan",
      qualification: "BPT - Physiotherapist",
      experience: "Dedicated Physiotherapist with 6+ Years of Experience",
      phone: "+91 9123860262",
      email: "pritishp957@gmail.com",
      address: "Kainsir road, ainthapali, Sambalpur, Odisha 768004",
      callNow: "Call Now",
      bookAppt: "Book Appointment",
      tagline: "Dedicated to Your Recovery & Well-being"
    },
    about: {
      title: "About Pritish Nanda Pradhan",
      description: "Dedicated and skilled Physiotherapist with 6 years of comprehensive experience in hospital settings, specializing in post-operative care, neuro-rehabilitation, cardiorespiratory therapy, and intensive care management. Strong clinical assessment skills combined with patient-centered approach to deliver evidence-based therapeutic interventions.",
      stats: {
        patients: "Patients Treated",
        experience: "Years Experience",
        success: "Success Rate",
        specializations: "Specializations"
      },
      values: {
        expertise: "Clinical Expertise",
        care: "Patient-Centered Care",
        recovery: "Optimal Recovery",
        approach: "Evidence-Based Approach"
      }
    },
    services: {
      title: "Our Services",
      subtitle: "Comprehensive Physiotherapy Treatments",
      list: {
        adhd: {
          name: "ADHD Therapy",
          desc: "Specialized therapy and management for ADHD patients with personalized treatment plans."
        },
        orthopedic: {
          name: "Orthopedic Physiotherapy",
          desc: "Treatment for musculoskeletal injuries, joint pain, and post-surgical rehabilitation."
        },
        sports: {
          name: "Sports Injury Rehabilitation",
          desc: "Comprehensive rehabilitation for sports-related injuries and performance enhancement."
        },
        postSurgery: {
          name: "Post-Surgery Rehabilitation",
          desc: "Specialized care for post-operative recovery and functional restoration."
        },
        geriatric: {
          name: "Geriatric Physiotherapy",
          desc: "Specialized care for elderly patients focusing on mobility and independence."
        },
        neuro: {
          name: "Neurological Rehabilitation",
          desc: "Treatment for neurological conditions including stroke, spinal cord injuries."
        },
        pediatric: {
          name: "Pediatric Physiotherapy",
          desc: "Specialized care for children with developmental and movement disorders."
        },
        manual: {
          name: "Manual Therapy",
          desc: "Hands-on techniques for pain relief and improved joint mobility."
        },
        electro: {
          name: "Electrotherapy",
          desc: "Advanced electrical stimulation techniques for pain management and healing."
        },
        exercise: {
          name: "Exercise Therapy",
          desc: "Customized exercise programs for strength, flexibility, and functional improvement."
        }
      }
    },
    gallery: {
      title: "Our Clinic Gallery",
      subtitle: "Modern Facilities & Professional Care"
    },
    testimonials: {
      title: "Patient Success Stories",
      subtitle: "Real experiences from our patients who found relief and recovery",
      viewAll: "View All Reviews"
    },
    beforeAfter: {
      title: "Transformation Gallery",
      subtitle: "See the remarkable progress our patients achieve through dedicated treatment",
      beforeLabel: "Before",
      afterLabel: "After"
    },
    pricing: {
      title: "Transparent Pricing & Packages",
      subtitle: "Choose the perfect treatment package for your recovery journey. No hidden costs, just honest pricing."
    },
    booking: {
      title: "Book Your Appointment",
      subtitle: "Quick and easy appointment booking. Get confirmation within 15 minutes via WhatsApp."
    },
    whatsapp: {
      quickBook: "Quick Book",
      bookNow: "Book Now",
      callNow: "Call Now",
      consultation: "Book Consultation",
      session: "Book Session", 
      homeVisit: "Home Visit",
      emergency: "Emergency"
    },
    contact: {
      title: "Get in Touch",
      subtitle: "Contact us for appointments and inquiries",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        message: "Message",
        submit: "Send Message"
      },
      info: {
        address: "Clinic Address",
        phone: "Phone Number",
        email: "Email Address",
        hours: "Working Hours"
      },
      details: {
        addressText: "Kainsir road, ainthapali, Sambalpur, Odisha 768004",
        phoneText: "+91 9123860262",
        emailText: "pritishp957@gmail.com",
        hoursText: "Mon - Sat: 9:00 AM - 9:00 PM"
      }
    },
    footer: {
      copyright: "© 2025 Pritish Nanda Pradhan Physiotherapy Clinic. All rights reserved.",
      quickLinks: "Quick Links"
    },
    admin: {
      login: "Admin Login",
      password: "Password",
      enter: "Enter",
      welcome: "Welcome to Admin Panel",
      logout: "Logout",
      error: "Incorrect password"
    }
  },
  hi: {
    nav: {
      home: "होम",
      about: "बारे में",
      services: "सेवाएं",
      gallery: "गैलरी",
      contact: "संपर्क",
      bookAppointment: "अपॉइंटमेंट बुक करें",
      backToHome: "होम पर वापस जाएं"
    },
    navigation: {
      backToHome: "होम पर वापस जाएं"
    },
    hero: {
      name: "प्रितीश नंद प्रधान",
      qualification: "बीपीटी - फिजियोथेरेपिस्ट",
      experience: "6+ वर्षों के अनुभव के साथ समर्पित फिजियोथेरेपिस्ट",
      phone: "+91 9123860262",
      email: "pritishp957@gmail.com",
      address: "कैंसिर रोड, ऐंथापली, संबलपुर, ओडिशा 768004",
      callNow: "अभी कॉल करें",
      bookAppt: "अपॉइंटमेंट बुक करें",
      tagline: "आपकी रिकवरी और कल्याण के लिए समर्पित"
    },
    about: {
      title: "प्रितीश नंद प्रधान के बारे में",
      description: "अस्पताल सेटिंग्स में 4 वर्षों के व्यापक अनुभव के साथ समर्पित और कुशल फिजियोथेरेपिस्ट, पोस्ट-ऑपरेटिव केयर, न्यूरो-रिहैबिलिटेशन, कार्डियोरेस्पिरेटरी थेरेपी और इंटेंसिव केयर मैनेजमेंट में विशेषज्ञता। साक्ष्य-आधारित चिकित्सीय हस्तक्षेप प्रदान करने के लिए रोगी-केंद्रित दृष्टिकोण के साथ मजबूत नैदानिक मूल्यांकन कौशल।",
      stats: {
        patients: "उपचारित मरीज़",
        experience: "वर्षों का अनुभव",
        success: "सफलता दर",
        specializations: "विशेषज्ञताएं"
      },
      values: {
        expertise: "नैदानिक विशेषज्ञता",
        care: "रोगी-केंद्रित देखभाल",
        recovery: "इष्टतम रिकवरी",
        approach: "साक्ष्य-आधारित दृष्टिकोण"
      }
    },
    services: {
      title: "हमारी सेवाएं",
      subtitle: "व्यापक फिजियोथेरेपी उपचार",
      list: {
        adhd: {
          name: "एडीएचडी थेरेपी",
          desc: "व्यक्तिगत उपचार योजनाओं के साथ एडीएचडी रोगियों के लिए विशेष चिकित्सा और प्रबंधन।"
        },
        orthopedic: {
          name: "ऑर्थोपेडिक फिजियोथेरेपी",
          desc: "मस्कुलोस्केलेटल चोटों, जोड़ों के दर्द और पोस्ट-सर्जिकल पुनर्वास का उपचार।"
        },
        sports: {
          name: "खेल चोट पुनर्वास",
          desc: "खेल-संबंधी चोटों के लिए व्यापक पुनर्वास और प्रदर्शन वृद्धि।"
        },
        postSurgery: {
          name: "सर्जरी के बाद पुनर्वास",
          desc: "पोस्ट-ऑपरेटिव रिकवरी और कार्यात्मक बहाली के लिए विशेष देखभाल।"
        },
        geriatric: {
          name: "वृद्धावस्था फिजियोथेरेपी",
          desc: "गतिशीलता और स्वतंत्रता पर केंद्रित बुजुर्ग रोगियों के लिए विशेष देखभाल।"
        },
        neuro: {
          name: "न्यूरोलॉजिकल पुनर्वास",
          desc: "स्ट्रोक, रीढ़ की हड्डी की चोटों सहित न्यूरोलॉजिकल स्थितियों का उपचार।"
        },
        pediatric: {
          name: "बाल चिकित्सा फिजियोथेरेपी",
          desc: "विकासात्मक और गति विकारों वाले बच्चों के लिए विशेष देखभाल।"
        },
        manual: {
          name: "मैनुअल थेरेपी",
          desc: "दर्द राहत और बेहतर जोड़ गतिशीलता के लिए हाथों से तकनीकें।"
        },
        electro: {
          name: "इलेक्ट्रोथेरेपी",
          desc: "दर्द प्रबंधन और उपचार के लिए उन्नत विद्युत उत्तेजना तकनीकें।"
        },
        exercise: {
          name: "व्यायाम चिकित्सा",
          desc: "शक्ति, लचीलेपन और कार्यात्मक सुधार के लिए अनुकूलित व्यायाम कार्यक्रम।"
        }
      }
    },
    gallery: {
      title: "हमारी क्लिनिक गैलरी",
      subtitle: "आधुनिक सुविधाएं और व्यावसायिक देखभाल"
    },
    testimonials: {
      title: "मरीजों की सफलता की कहानियां",
      subtitle: "हमारे मरीजों के वास्तविक अनुभव जिन्होंने राहत और रिकवरी पाई",
      viewAll: "सभी समीक्षाएं देखें"
    },
    beforeAfter: {
      title: "रूपांतरण गैलरी", 
      subtitle: "समर्पित उपचार के माध्यम से हमारे मरीजों द्वारा हासिल की गई उल्लेखनीय प्रगति देखें",
      beforeLabel: "पहले",
      afterLabel: "बाद में"
    },
    pricing: {
      title: "पारदर्शी मूल्य निर्धारण और पैकेज",
      subtitle: "अपनी रिकवरी यात्रा के लिए सही उपचार पैकेज चुनें। कोई छुपी हुई लागत नहीं, केवल ईमानदार मूल्य निर्धारण।"
    },
    booking: {
      title: "अपना अपॉइंटमेंट बुक करें",
      subtitle: "त्वरित और आसान अपॉइंटमेंट बुकिंग। व्हाट्सएप द्वारा 15 मिनट के भीतर पुष्टि प्राप्त करें।"
    },
    whatsapp: {
      quickBook: "त्वरित बुकिंग",
      bookNow: "अभी बुक करें",
      callNow: "अभी कॉल करें",
      consultation: "परामर्श बुक करें",
      session: "सेशन बुक करें",
      homeVisit: "होम विज़िट",
      emergency: "आपातकाल"
    },
    contact: {
      title: "संपर्क में रहें",
      subtitle: "अपॉइंटमेंट और पूछताछ के लिए हमसे संपर्क करें",
      form: {
        name: "पूरा नाम",
        email: "ईमेल पता",
        phone: "फोन नंबर",
        message: "संदेश",
        submit: "संदेश भेजें"
      },
      info: {
        address: "क्लिनिक का पता",
        phone: "फोन नंबर",
        email: "ईमेल पता",
        hours: "कार्य समय"
      },
      details: {
        addressText: "कैंसिर रोड, ऐंथापली, संबलपुर, ओडिशा 768004",
        phoneText: "+91 9123860262",
        emailText: "pritishp957@gmail.com",
        hoursText: "सोम - शनि: सुबह 9:00 - रात 9:00"
      }
    },
    footer: {
      copyright: "© 2025 प्रितीश नंद प्रधान फिजियोथेरेपी क्लिनिक। सभी अधिकार सुरक्षित।",
      quickLinks: "त्वरित लिंक"
    },
    admin: {
      login: "एडमिन लॉगिन",
      password: "पासवर्ड",
      enter: "दर्ज करें",
      welcome: "एडमिन पैनल में आपका स्वागत है",
      logout: "लॉगआउट",
      error: "गलत पासवर्ड"
    }
  },
  or: {
    nav: {
      home: "ଘର",
      about: "ବିଷୟରେ",
      services: "ସେବାଗୁଡ଼ିକ",
      gallery: "ଗ୍ୟାଲେରୀ",
      contact: "ଯୋଗାଯୋଗ",
      bookAppointment: "ନିଯୁକ୍ତି ବୁକ୍ କରନ୍ତୁ",
      backToHome: "ଘରକୁ ଫେରନ୍ତୁ"
    },
    navigation: {
      backToHome: "ଘରକୁ ଫେରନ୍ତୁ"
    },
    hero: {
      name: "ପ୍ରୀତୀଶ ନନ୍ଦ ପ୍ରଧାନ",
      qualification: "ବିପିଟି - ଫିଜିଓଥେରାପିସ୍ଟ",
      experience: "6+ ବର୍ଷର ଅଭିଜ୍ଞତା ସହିତ ସମର୍ପିତ ଫିଜିଓଥେରାପିସ୍ଟ",
      phone: "+91 9123860262",
      email: "pritishp957@gmail.com",
      address: "କେନ୍ସିର ରୋଡ଼, ଐଁଥାପାଲି, ସମ୍ବଲପୁର, ଓଡ଼ିଶା ୭୬୮୦୦୪",
      callNow: "ବର୍ତ୍ତମାନ କଲ କରନ୍ତୁ",
      bookAppt: "ଆପଏଣ୍ଟମେଣ୍ଟ ବୁକ କରନ୍ତୁ",
      tagline: "ଆପଣଙ୍କ ପୁନରୁଦ୍ଧାର ଏବଂ କଲ୍ୟାଣ ପାଇଁ ଉତ୍ସର୍ଗୀକୃତ"
    },
    about: {
      title: "ପ୍ରୀତୀଶ ନନ୍ଦ ପ୍ରଧାନଙ୍କ ବିଷୟରେ",
      description: "ହସ୍ପିଟାଲ ସେଟିଂରେ 4 ବର୍ଷର ବ୍ୟାପକ ଅଭିଜ୍ଞତା ସହିତ ସମର୍ପିତ ଏବଂ କୁଶଳ ଫିଜିଓଥେରାପିସ୍ଟ, ପୋଷ୍ଟ-ଅପରେଟିଭ କେୟାର, ନ୍ୟୁରୋ-ରିହାବିଲିଟେସନ, କାର୍ଡିଓରେସ୍ପିରେଟୋରୀ ଥେରାପି ଏବଂ ଇଣ୍ଟେନସିଭ କେୟାର ମ୍ୟାନେଜମେଣ୍ଟରେ ବିଶେଷଜ୍ଞତା। ପ୍ରମାଣ-ଆଧାରିତ ଚିକିତ୍ସକ ହସ୍ତକ୍ଷେପ ପ୍ରଦାନ କରିବା ପାଇଁ ରୋଗୀ-କେନ୍ଦ୍ରିତ ଆଭିମୁଖ୍ୟ ସହିତ ଦୃଢ଼ କ୍ଲିନିକାଲ ମୂଲ୍ୟାଙ୍କନ କୌଶଳ।",
      stats: {
        patients: "ଚିକିତ୍ସିତ ରୋଗୀ",
        experience: "ବର୍ଷର ଅଭିଜ୍ଞତା",
        success: "ସଫଳତା ହାର",
        specializations: "ବିଶେଷଜ୍ଞତା"
      },
      values: {
        expertise: "କ୍ଲିନିକାଲ୍ ଦକ୍ଷତା",
        care: "ରୋଗୀ-କେନ୍ଦ୍ରିତ ଯତ୍ନ",
        recovery: "ସର୍ବୋଚ୍ଚ ପୁନରୁଦ୍ଧାର",
        approach: "ପ୍ରମାଣ-ଆଧାରିତ ଉପାୟ"
      }
    },
    services: {
      title: "ଆମର ସେବାଗୁଡ଼ିକ",
      subtitle: "ବ୍ୟାପକ ଫିଜିଓଥେରାପି ଚିକିତ୍ସା",
      list: {
        adhd: {
          name: "ଏଡିଏଚଡି ଥେରାପି",
          desc: "ବ୍ୟକ୍ତିଗତ ଚିକିତ୍ସା ଯୋଜନା ସହିତ ଏଡିଏଚଡି ରୋଗୀମାନଙ୍କ ପାଇଁ ବିଶେଷ ଥେରାପି ଏବଂ ପରିଚାଳନା।"
        },
        orthopedic: {
          name: "ଅର୍ଥୋପେଡିକ୍ ଫିଜିଓଥେରାପି",
          desc: "ମାଂସପେଶୀ-କଙ୍କାଳ ଆଘାତ, ଗଣ୍ଠି ଯନ୍ତ୍ରଣା ଏବଂ ଅସ୍ତ୍ରୋପଚାର ପରବର୍ତ୍ତୀ ପୁନର୍ବାସ ପାଇଁ ଚିକିତ୍ସା।"
        },
        sports: {
          name: "କ୍ରୀଡା ଆଘାତ ପୁନର୍ବାସ",
          desc: "କ୍ରୀଡା-ସମ୍ବନ୍ଧୀୟ ଆଘାତ ପାଇଁ ବ୍ୟାପକ ପୁନର୍ବାସ ଏବଂ କାର୍ଯ୍ୟକ୍ଷମତା ବୃଦ୍ଧି।"
        },
        postSurgery: {
          name: "ଅସ୍ତ୍ରୋପଚାର ପରେ ପୁନର୍ବାସ",
          desc: "ପୋଷ୍ଟ-ଅପରେଟିଭ୍ ପୁନରୁଦ୍ଧାର ଏବଂ କାର୍ଯ୍ୟକ୍ଷମ ପୁନରୁଦ୍ଧାର ପାଇଁ ବିଶେଷ ଯତ୍ନ।"
        },
        geriatric: {
          name: "ବୃଦ୍ଧାବସ୍ଥା ଫିଜିଓଥେରାପି",
          desc: "ଗତିଶୀଳତା ଏବଂ ସ୍ୱାଧୀନତା ଉପରେ ଧ୍ୟାନ ଦେଇ ବୃଦ୍ଧ ରୋଗୀମାନଙ୍କ ପାଇଁ ବିଶେଷ ଯତ୍ନ।"
        },
        neuro: {
          name: "ସ୍ନାୟୁବିଜ୍ଞାନ ପୁନର୍ବାସ",
          desc: "ଷ୍ଟ୍ରୋକ୍, ମେରୁଦଣ୍ଡର ଆଘାତ ସମେତ ସ୍ନାୟୁବିଜ୍ଞାନ ଅବସ୍ଥା ପାଇଁ ଚିକିତ୍ସା।"
        },
        pediatric: {
          name: "ଶିଶୁ ଫିଜିଓଥେରାପି",
          desc: "ବିକାଶମୂଳକ ଏବଂ ଗତି ବିକୃତି ଥିବା ପିଲାମାନଙ୍କ ପାଇଁ ବିଶେଷ ଯତ୍ନ।"
        },
        manual: {
          name: "ମାନୁଆଲ୍ ଥେରାପି",
          desc: "ଯନ୍ତ୍ରଣା ଉପଶମ ଏବଂ ଉନ୍ନତ ଗଣ୍ଠି ଗତିଶୀଳତା ପାଇଁ ହାତର କୌଶଳ।"
        },
        electro: {
          name: "ଇଲେକ୍ଟ୍ରୋଥେରାପି",
          desc: "ଯନ୍ତ୍ରଣା ପରିଚାଳନା ଏବଂ ଆରୋଗ୍ୟ ପାଇଁ ଉନ୍ନତ ବିଦ୍ୟୁତୀୟ ଉତ୍ତେଜନା କୌଶଳ।"
        },
        exercise: {
          name: "ବ୍ୟାୟାମ ଥେରାପି",
          desc: "ଶକ୍ତି, ନମନୀୟତା ଏବଂ କାର୍ଯ୍ୟକ୍ଷମ ଉନ୍ନତି ପାଇଁ କଷ୍ଟମାଇଜ୍ ବ୍ୟାୟାମ କାର୍ଯ୍ୟକ୍ରମ।"
        }
      }
    },
    gallery: {
      title: "ଆମର କ୍ଲିନିକ୍ ଗ୍ୟାଲେରୀ",
      subtitle: "ଆଧୁନିକ ସୁବିଧା ଏବଂ ବୃତ୍ତିଗତ ଯତ୍ନ"
    },
    testimonials: {
      title: "ରୋଗୀଙ୍କ ସଫଳତାର କାହାଣୀ",
      subtitle: "ଆମର ରୋଗୀମାନଙ୍କର ପ୍ରକୃତ ଅଭିଜ୍ଞତା ଯେଉଁମାନେ ଆରାମ ଏବଂ ସୁସ୍ଥତା ପାଇଛନ୍ତି",
      viewAll: "ସମସ୍ତ ସମୀକ୍ଷା ଦେଖନ୍ତୁ"
    },
    beforeAfter: {
      title: "ରୂପାନ୍ତର ଗ୍ୟାଲେରୀ",
      subtitle: "ଉତ୍ସର୍ଗୀକୃତ ଚିକିତ୍ସା ମାଧ୍ୟମରେ ଆମର ରୋଗୀମାନେ ହାସଲ କରିଥିବା ଉଲ୍ଲେଖନୀୟ ପ୍ରଗତି ଦେଖନ୍ତୁ",
      beforeLabel: "ପୂର୍ବରୁ",
      afterLabel: "ପରେ"
    },
    pricing: {
      title: "ସ୍ୱଚ୍ଛ ମୂଲ୍ୟ ନିର୍ଧାରଣ ଏବଂ ପ୍ୟାକେଜ",
      subtitle: "ଆପଣଙ୍କ ସୁସ୍ଥତା ଯାତ୍ରା ପାଇଁ ଉପଯୁକ୍ତ ଚିକିତ୍ସା ପ୍ୟାକେଜ ବାଛନ୍ତୁ। କୌଣସି ଲୁକ୍କାୟିତ ଖର୍ଚ୍ଚ ନାହିଁ, କେବଳ ସଚ୍ଚୋଟ ମୂଲ୍ୟ ନିର୍ଧାରଣ।"
    },
    booking: {
      title: "ଆପଣଙ୍କର ନିଯୁକ୍ତି ବୁକ୍ କରନ୍ତୁ",
      subtitle: "ଶୀଘ୍ର ଏବଂ ସହଜ ନିଯୁକ୍ତି ବୁକିଂ। ୱାଟ୍ସଆପ୍ ମାଧ୍ୟମରେ 15 ମିନିଟ୍ ମଧ୍ୟରେ ନିଶ୍ଚିତତା ପାଆନ୍ତୁ।"
    },
    whatsapp: {
      quickBook: "ଶୀଘ୍ର ବୁକ୍",
      bookNow: "ବର୍ତ୍ତମାନ ବୁକ୍ କରନ୍ତୁ",
      callNow: "ବର୍ତ୍ତମାନ କଲ୍ କରନ୍ତୁ",
      consultation: "ପରାମର୍ଶ ବୁକ୍ କରନ୍ତୁ",
      session: "ସେସନ୍ ବୁକ୍ କରନ୍ତୁ",
      homeVisit: "ଘର ପରିଦର୍ଶନ",
      emergency: "ଜରୁରୀକାଳୀନ"
    },
    contact: {
      title: "ଯୋଗାଯୋଗରେ ରୁହନ୍ତୁ",
      subtitle: "ନିଯୁକ୍ତି ଏବଂ ପଚାରିବା ପାଇଁ ଆମ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ",
      form: {
        name: "ପୂର୍ଣ୍ଣ ନାମ",
        email: "ଇମେଲ୍ ଠିକଣା",
        phone: "ଫୋନ୍ ନମ୍ବର",
        message: "ବାର୍ତ୍ତା",
        submit: "ବାର୍ତ୍ତା ପଠାନ୍ତୁ"
      },
      info: {
        address: "କ୍ଲିନିକ୍ ଠିକଣା",
        phone: "ଫୋନ୍ ନମ୍ବର",
        email: "ଇମେଲ୍ ଠିକଣା",
        hours: "କାର୍ଯ୍ୟ ସମୟ"
      },
      details: {
        addressText: "କେନ୍ସିର ରୋଡ଼, ଐଁଥାପାଲି, ସମ୍ବଲପୁର, ଓଡ଼ିଶା ୭୬୮୦୦୪",
        phoneText: "+91 9123860262",
        emailText: "pritishp957@gmail.com",
        hoursText: "ସୋମ - ଶନି: ସକାଳ ୯:୦୦ - ରାତି ୯:୦୦"
      }
    },
    footer: {
      copyright: "© 2025 ପ୍ରୀତୀଶ ନନ୍ଦ ପ୍ରଧାନ ଫିଜିଓଥେରାପି କ୍ଲିନିକ୍। ସମସ୍ତ ଅଧିକାର ସଂରକ୍ଷିତ।",
      quickLinks: "ତ୍ୱରିତ ଲିଙ୍କ"
    },
    admin: {
      login: "ଆଡମିନ୍ ଲଗଇନ୍",
      password: "ପାସୱର୍ଡ",
      enter: "ପ୍ରବେଶ କରନ୍ତୁ",
      welcome: "ଆଡମିନ୍ ପ୍ୟାନେଲରେ ଆପଣଙ୍କୁ ସ୍ୱାଗତ",
      logout: "ଲଗଆଉଟ୍",
      error: "ଭୁଲ ପାସୱର୍ଡ"
    }
  }
};